var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c("div", [
          _c("div", { staticClass: "card-item mt-6 options" }, [
            _c(
              "div",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "is-button-secondary",
                    class:
                      _vm.evaluationOption === "existing" ? "is-primary" : "",
                    attrs: { id: "existing-evaluation-button", rounded: "" },
                    on: {
                      click: function ($event) {
                        return _vm.setEvaluationOption("existing")
                      },
                    },
                  },
                  [_vm._v(" Retomar ")]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-item transition-fast selected-option-content mt-2",
                    class:
                      _vm.evaluationOption === "existing" ? "show" : "hide",
                  },
                  [
                    _c("FindEntitiesInput", {
                      staticClass: "search-evaluations",
                      attrs: {
                        id: "find-evaluations-input",
                        placeholder: "Buscar comprobación por RUT",
                        "show-date": "true",
                        expanded: true,
                        finder: _vm.finder,
                      },
                      on: {
                        select: function ($event) {
                          return _vm.clickedOnEvaluation($event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "is-button-secondary",
                    class: _vm.evaluationOption === "new" ? "is-primary" : "",
                    attrs: { id: "new-evaluation-button", rounded: "" },
                    on: {
                      click: function ($event) {
                        return _vm.setEvaluationOption("new")
                      },
                    },
                  },
                  [_vm._v(" Nueva comprobación ")]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-item transition-fast selected-option-content mt-2",
                    class: _vm.evaluationOption === "new" ? "show" : "hide",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "switch" },
                      [
                        _c("p", [_vm._v("Guardar comprobación")]),
                        _c("b-switch", {
                          attrs: {
                            id: "save-evaluation-switch",
                            size: "is-small",
                          },
                          model: {
                            value: _vm.newEvaluation.save,
                            callback: function ($$v) {
                              _vm.$set(_vm.newEvaluation, "save", $$v)
                            },
                            expression: "newEvaluation.save",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.newEvaluation.save
                      ? _c(
                          "b-field",
                          { attrs: { message: _vm.newEvaluation.message } },
                          [
                            _c("b-input", {
                              attrs: {
                                id: "id-number-input",
                                "icon-clickable": "",
                                placeholder: "RUT a comprobar",
                                size: "is-small",
                                rounded: "",
                              },
                              model: {
                                value: _vm.idNumber,
                                callback: function ($$v) {
                                  _vm.idNumber = $$v
                                },
                                expression: "idNumber",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        staticClass: "is-button-secondary",
                        attrs: {
                          id: "continue-evaluation-button",
                          disabled:
                            _vm.newEvaluation.save &&
                            !_vm.newEvaluation.validIdNumber,
                          loading: _vm.newEvaluation.isLoading,
                          rounded: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.continueNewEvaluation()
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.newEvaluation.save
                                ? "Crear Comprobación"
                                : "Probar comprobador"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }